import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Select,
  MenuItem,
  Button,
  InputLabel,
  FormControl,
  Card,
  CardContent,
  AppBar,
  Toolbar,
  Avatar,
  Divider,
  Paper,
  selectClasses,
  IconButton,
} from '@mui/material';
import { fetchAlmacenes, fetchCategorias, fetchListasDePrecios } from '../../../utils/generalsFetch';
import Selector from '../../../components/Selector';
import { capitalizeFirstLetter } from '../../../utils/generalFunctions';
import { a } from '@react-spring/web';
import { Add, RemoveCircleOutline } from '@mui/icons-material';
import AutocompleteWithAdd from '../../../components/AutocompleteWithAdd';
import CrearListadePreciosDialog from '../listaprecios/crearlistadialog';
import AccessDeniedBox from '../../../components/AccessDeniedBox';
import Header from '../../../components/Header';
import { useTourContext } from '../../../components/TourProvider';

const ProductsForm = ({onClose}) => {
  const { startSpecificTour } = useTourContext();
  const [categorias, setCategorias] = useState([])
  const [campos, setCampos] = useState([])
  const [almacenes, setAlmacenes] = useState([])
  const [type, setType] = useState('producto');
  const [category, setCategory] = useState('');
  const [categoryName, setCategoryName] = useState('');
  const [warehouse, setWarehouse] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [listasDePrecios, setListasDePrecios] = useState([]);
  const [listasDePreciosOriginales, setListasDePreciosOriginales] = useState([]);
  const [pricelistselected, setPricelistselected] = useState([{value: "", label: "", price: ""}])
  const [accessDenied, setAccessDenied] = React.useState(false);
  const [openCrearListadePrecios, setOpenCrearListadePrecios] = useState(false);
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    precio: '',
    costo: '',
  });



  useEffect(() => {
    fetchCategorias({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') }).then(data => {
      setCategorias(data)
    }).catch((error) => {
      setAccessDenied(true);
    })
    fetchAlmacenes({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') }).then(data => {
      setAlmacenes(data)
    }).catch((error) => {
      setAccessDenied(true);
    })
    fetchListasDePrecios({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') }).then(data => {
      setListasDePreciosOriginales(data)
      setListasDePrecios(data)
    }).catch((error) => {
      setAccessDenied(true);
    })
  }, []);


  const handleChange = (e,id) => {
    setFormData({ ...formData, [id]: e.target.value });
  };
  
  const saveProduct = async () => {

    var cantidad = formData.cantidad?formData.cantidad:1;
    let camposObj = JSON.parse(campos);
    camposObj = camposObj.filter(campo => campo.id !== 'cantidad');
    
    try {
      // Construir el objeto de datos a enviar
      const dataToSend = {
        nombre: type=="Serializado"?formData.id:formData.nombre,
        descripcion: formData.descripcion,
        precio: formData.precio_venta,
        costo: formData.costo,
        precio_minimo: formData.precio_minimo,
        precio_x_mayor: formData.precio_x_mayor,
        cantidad: cantidad,
        idcategoria: category,
        idalmacen: warehouse,
        idlistaprecios: pricelistselected.map(item => item.value),
        valorlistaprecios: pricelistselected.map(item => item.price),
        idcompany: localStorage.getItem('idcompany'),
        created_by: localStorage.getItem('id'),
        campos: camposObj?camposObj.reduce((acc, campo) => {
          acc[campo.id] = formData[campo.id] || '';
          return acc;
        }, {}) : {},
      };
      // Llamada a la API para guardar el producto
      const response = await fetch(process.env.REACT_APP_SERVER_URL+'/api/productos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify(dataToSend),
      });

      if (!response.ok) {
        throw new Error('Error al guardar el producto');
      }

      const result = await response.json();
      // Puedes mostrar un mensaje de éxito o cerrar el formulario
      if (onClose) onClose();
      

    } catch (error) {
      // Manejo de errores
      alert(error.message || 'Ocurrió un error al guardar el producto');
    }
  };

  const handleChangePricelist = (event,index) => {
    if (!event){
      var object = listasDePreciosOriginales.filter(option => option.value == pricelistselected[index].value);
      setListasDePrecios(listasDePreciosOriginales);

      const newPricelist = [...pricelistselected];
      newPricelist[index].label = "";
      newPricelist[index].price = "";
      newPricelist[index].value = "";
      setPricelistselected(newPricelist);
  
 
      return;
    }
    const newPricelist = [...pricelistselected];
    newPricelist[index].label = event.label;
    newPricelist[index].price = event.price;
    newPricelist[index].value = event.value;
    setListasDePrecios(listasDePrecios?listasDePrecios.filter(option => option.value !== event.value):[])
    setPricelistselected(newPricelist);
  }
  const handleAddPricelist = () => {
    setPricelistselected([...pricelistselected, {value: "", label: "", price: "" }]);
  }

  const createPricelist = () => {
    setOpenCrearListadePrecios(true);
  }

  
  const handleGuardarListadePrecios = () => {
    setOpenCrearListadePrecios(false);
    fetchListasDePrecios({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') }).then(data => {
      setListasDePreciosOriginales(data)
      var newLista = data.filter(option => {
        var exists = pricelistselected.some(item => item.value === option.value);
        if (!exists) {
          return option;
        }

      })
      //alert(JSON.stringify(newLista))
      setListasDePrecios(newLista)
    })

  }
   
  return (
    <>
    <Header parent={"Logistica y Almacenes"} child={"Productos"} onStartTour={startSpecificTour}/>
    <Box sx={{ fontFamily: 'Inter, "Noto Sans", sans-serif', bgcolor: '#fff', minHeight: '100vh', p: 3 }}>

      <CrearListadePreciosDialog open={openCrearListadePrecios} onClose={()=>{handleGuardarListadePrecios()}}/>
      <Grid container spacing={4}>
        {/* Formulario Principal */}
        <Grid size={category.length > 0 ? 8 : 12}>
          <Box sx={{ my: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h4" fontWeight={700} sx={{ mt: 1 }}>Agregar Producto o Servicio</Typography>
          </Box>

          {
            category.length > 0 ? (
              <>
              {!accessDenied ? 
              <Paper variant="outlined" sx={{ p: 3, borderRadius: 3, minWidth: 500}} data-tour="formulario-principal">
                <FormControl fullWidth sx={{mb:2}} data-tour="seleccionar-categoria">
                    <Selector
                      value={category}
                      onChange={(e) => {
                        setCategory(e.target.value);
                        setCategoryName(categorias.find(cat => cat.value == e.target.value).label);
                        setCampos(categorias.find(cat => cat.value === e.target.value).fields);
                        setType(categorias.find(cat => cat.value == e.target.value).tipo)
                      }}
                      options={categorias}
                      placeholder="Categoría"
                    />
                </FormControl>
    
                <Grid container spacing={2} mt={2}>
                  <Grid size={6}>
                    <FormControl fullWidth sx={{mb:2}}>
                      <Selector
                        value={warehouse}
                        onChange={(e) => {
                          setWarehouse(e.target.value)
                          setWarehouseName(almacenes.find(almacen => almacen.value === e.target.value).label)
                        }}
                        options={almacenes}
                        placeholder="Almacén"
                      />
                    </FormControl>

                  </Grid>
                  {campos.length > 0 && JSON.parse(campos).map((campo) => (
                    <Grid item size={6} data-tour="campos-personalizados">
                      {
                        campo.type === 'texto' || campo.type === 'numero' || campo.type=="monto"? (
                          <TextField fullWidth type={campo.type === 'numero' ? 'number' : 'text'}
                           placeholder={type=="serializado" ? campo.name!='id' ? capitalizeFirstLetter(campo.name) : capitalizeFirstLetter(campo.alias) : capitalizeFirstLetter(campo.name)}
                           name={campo.name} value={formData[campo.id]} onChange={(e)=>handleChange(e,campo.id)} />
                        ) : (
                          <Selector
                            value={formData[campo.id]}
                            onChange={(e) => handleChange(e,campo.id)}
                            options={campo.options.map(option => ({
                              label: option,
                              value: option
                            }))}
                            placeholder={capitalizeFirstLetter(campo.name)}
                          />
                        )
                        }
                    </Grid>
                  ))}
                </Grid>
              </Paper>
              :
              <Box>
                <br></br>
                <br></br>
                <AccessDeniedBox
                  title={'Acceso denegado'}
                  message={'No tienes permisos para ver esta sección de Productos. Contacta a tu administrador para solicitar acceso o verifica tus roles y permisos.'}
                />
              </Box>
              }
              </>
            ) : (
              <Paper variant="outlined" sx={{ p: 3, borderRadius: 3, minWidth: 500, textAlign: 'center', height:200, marginTop:10}}>
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column'}}>

                  <Typography variant="body2" color="text.secondary">Seleccione una categoría para continuar</Typography>
                  <FormControl fullWidth sx={{mb:2, mt:3}}>
                    <Selector
                      value={category}
                      onChange={(e) => {
                        setCategory(e.target.value);
                        setCampos(categorias.find(cat => cat.value === e.target.value).fields);
                        setCategoryName(categorias.find(cat => cat.value == e.target.value).label);
                        setType(categorias.find(cat => cat.value == e.target.value).tipo)
                      }}
                      options={categorias}
                      placeholder="Categoría"
                    />
                </FormControl>
    
                </Box>
              </Paper>
            )
          }

          {category.length>0 && (
            <Paper variant="outlined" sx={{ p: 3, borderRadius: 3, minWidth: 500, mt:3}} data-tour="listas-de-precios">
                <Typography fontWeight={"bold"} textAlign={"left"} mb={2}>Listas de precios asociadas</Typography>
                <Divider sx={{ my: 1 }} />

              <Grid container spacing={2} justifyContent={"center"}>
              {pricelistselected.map((pricelist, idx) => (
                <React.Fragment key={idx}>
                  <Grid item size={4}>
                    <AutocompleteWithAdd
                    label="Lista de precios"
                    options={listasDePrecios}
                    value={pricelistselected.find(option => option.value === pricelist.value)||null}
                    onChange={(val) => handleChangePricelist(val,idx)}
                    onAdd={createPricelist}/>
                  </Grid>

                  <Grid item size={4}>
                    <TextField
                      fullWidth
                      value={pricelist.price}
                      onChange={(e) => {
                        const newPricelist = [...pricelistselected];
                        newPricelist[idx].price = e.target.value;
                        setPricelistselected(newPricelist);
                      }}
                      placeholder="Valor"
                      type="number"
                    />
                  </Grid>

                  <Grid item size={2}>
                    <IconButton onClick={()=>{
                      const newPricelist = [...pricelistselected];
                      newPricelist.splice(idx,1);
                      setPricelistselected(newPricelist);
                      setListasDePrecios([...listasDePrecios, pricelistselected[idx]])
                    }}>
                      <RemoveCircleOutline sx={{color:"red"}}/>
                    </IconButton>
                  </Grid>
                </React.Fragment>
              ))}
              </Grid>
              <Grid size={12} sx={{textAlign:"right"}}>
                <Button variant="outlined" startIcon={<Add/>}  sx={{mt:2,fontWeight:"bold",color:"primary.main",borderColor:"primary.main"}} onClick={handleAddPricelist}>Agregar lista de precios</Button>
              </Grid>
            </Paper>
          )}
        </Grid>

        {/* Resumen */}
        {category.length > 0 && (
          <Grid size={4} sx={{mt:10, borderLeft:1, borderColor:'#eee', pl:3}} data-tour="resumen-producto">
            <Typography variant="h6" fontWeight={700} mb={2}>Resumen del producto/servicio</Typography>
            <Grid container spacing={2} ml={4}>
              <Grid size={12}>
                <Divider sx={{ my: 1 }} />
              </Grid>
              <Grid size={5}>
                <Typography textAlign={"left"} variant="body2" fontWeight={"bold"} color="text.secondary">Tipo</Typography>
              </Grid>
              <Grid size={7}>
                <Typography textAlign={"left"} fontWeight={500}>{type=="serializado" || type=="generico" ? 'Producto '+ capitalizeFirstLetter(type) : 'Servicio'}</Typography>
              </Grid>
              <Grid size={12}>
                <Divider sx={{ my: 1 }} />
              </Grid>
              <Grid size={5}>
                <Typography textAlign={"left"} variant="body2" fontWeight={"bold"} color="text.secondary">Categoría</Typography>
              </Grid>
              <Grid size={7}>
                <Typography textAlign={"left"} fontWeight={500}>{capitalizeFirstLetter(categoryName)}</Typography>
              </Grid>
              <Grid size={12}>
                <Divider sx={{ my: 1 }} />
              </Grid>
              <Grid size={5}>
                <Typography textAlign={"left"} variant="body2" fontWeight={"bold"} color="text.secondary">Almacén</Typography>
              </Grid>
              <Grid size={7}>
                <Typography textAlign={"left"} fontWeight={500}>{capitalizeFirstLetter(warehouseName)}</Typography>
              </Grid>
              <Grid size={12}>
                <Divider sx={{ my: 1 }} />
              </Grid>
              <Grid size={5}>
                <Typography textAlign={"left"}  variant="body2" fontWeight={"bold"} color="text.secondary">
                  {type=="serializado"?capitalizeFirstLetter(JSON.parse(campos).find(field => field.name == 'id').alias=='' ? 'Nombre' : JSON.parse(campos).find(field => field.name == 'id').alias):"Nombre"}</Typography>
              </Grid>
              <Grid size={7}>
                <Typography textAlign={"left"} fontWeight={500}>{type=="serializado"?formData.id:formData.nombre}</Typography>
              </Grid>
              <Grid size={12}>
                <Divider sx={{ my: 1 }} />
              </Grid>
              <Grid size={5}>
                <Typography textAlign={"left"} variant="body2" fontWeight={"bold"} color="text.secondary">Costo</Typography>
              </Grid>
              <Grid size={7}>
                <Typography textAlign={"left"} fontWeight={500}>{formData.costo}</Typography>
              </Grid>
              <Grid size={12}>
                <Divider sx={{ my: 1 }} />
              </Grid>
              <Grid size={5}>
                <Typography textAlign={"left"} variant="body2" fontWeight={"bold"} color="text.secondary">Precio</Typography>
              </Grid>
              <Grid size={7}>
                <Typography textAlign={"left"} fontWeight={500}>{formData.precio_venta}</Typography>
              </Grid>
              <Grid size={12}>
                <Divider sx={{ my: 1 }} />
              </Grid>
              {type!="serializado" && 
                <>
              <Grid size={5}>
                <Typography textAlign={"left"} variant="body2" fontWeight={"bold"} color="text.secondary">Cantidad</Typography>
              </Grid>
              <Grid size={7}>
                <Typography textAlign={"left"} fontWeight={500}>{formData.cantidad}</Typography>
              </Grid>
              </>
              }  
            </Grid>
          </Grid>
        )}
      </Grid>

      <Box sx={{ position: 'fixed', bottom: 0, left: 0, width: '100%', bgcolor: 'white', p: 2, borderTop: '1px solid #eee', textAlign: 'right', }} data-tour="acciones-guardar">
        <Button variant="outlined"  sx={{width:200,fontWeight:"bold", marginRight:5}} onClick={()=>{onClose()}}>Cancelar</Button>
        {
          category.length > 0 && (
            <>
              <Button variant="contained" color="primarybutton" sx={{width:200,fontWeight:"bold", marginRight:5}} onClick={saveProduct}>Guardar</Button>
              <Button variant="contained" color="primarybutton" sx={{width:200,fontWeight:"bold"}}>Guardar y agregar otro</Button>
            </>
          ) 
        }
      </Box>
    </Box>
    </>
  );
};

export default ProductsForm;
